import { useTeamContext } from "@/Common/Contex/TeamContext";
import HttpService from "@/hooks/Https-services";
import { getCurrentAuth } from "@/hooks/useAxiosPrivate";
import { setAuth } from "@/hooks/useRefreshToken";
import ClipsRow from "@/Pages/Clips/ClipsRow";
import ChannelHighLights from "@/Pages/ShortContent/ChannelHighLights";
import { APIRoutes } from "@/utils/constants";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import useConfig from "@/hooks/useConfig";

const HighLightsAndShortContent = () => {
  const { currentSelectedTeam }: any = useTeamContext();
  const [gameIds, setGameIds] = useState<any[]>([]);
  const config = useConfig();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const GetSchedule = useCallback(async () => {
    if (!currentSelectedTeam?.team_id) {
      return;
    }
    try {
      setIsLoading(true);
      const params: any = {
        status: "vod",
        page: 1,
        limit: 16,
        customer: config.customer,
        team: currentSelectedTeam?.team_id,
      };
      const games = await HttpService.getapi(
        `${APIRoutes.TeamEventsList}?` + new URLSearchParams(params)
      );

      setGameIds(games?.data?.data?.map((el: any) => el?.game_id));
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }, [config.customer, currentSelectedTeam?.team_id]);
  useEffect(() => {
    GetSchedule();
  }, [GetSchedule]);
  return (
    <>
      {/* <ClipsRow type_name="Highlights" clips={highlights} /> */}
      {!!gameIds?.length && (
        <ChannelHighLights
          channel_id={""}
          channel_name={""}
          link={false}
          game_ids={gameIds}
          type_name={"Condensed Games"}
          type={3}
        />
      )}
    </>
  );
};
export default HighLightsAndShortContent;
